var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalibrationPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27176 0C12.8398 0 16.5435 3.70371 16.5435 8.27176C16.5435 12.8398 12.8398 16.5435 8.27176 16.5435C3.70371 16.5435 0 12.8398 0 8.27176C0 3.70371 3.70371 0 8.27176 0ZM7.29972 5.06888C7.29972 3.7993 9.23437 3.79795 9.23437 5.07157V8.53833L11.4194 9.69481C11.4302 9.7002 11.441 9.70693 11.4504 9.71501L11.4693 9.72847C12.4844 10.3936 11.5406 11.9916 10.4555 11.3642L10.4514 11.3616L7.80728 9.94523C7.49763 9.77963 7.29703 9.45113 7.29703 9.0984H7.29837L7.29972 5.06888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibrationPendingIcon);
export default __webpack_public_path__ + "static/media/calibration_pending_icon.2824101896678bf1a768d06ca75c3bda.svg";
export { ForwardRef as ReactComponent };